import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MxValidationManagerService, RegexTypeInfo, ValidationDataMxObj, ValidationRegex, ValidationType, Validator} from 'mx-core';
import {map} from 'rxjs/internal/operators/map';
import {PrlInitializer} from './prl-initializer.interface';

const VALIDATORS_DATA_URL: string = '/rest/validation/data';

@Injectable({
    providedIn: 'root'
})
export class PrlValidationManagerService implements PrlInitializer, MxValidationManagerService {

    private validators: { [key: string]: Validator } = {};
    private regexes: { [p: string]: RegexTypeInfo } = {};

    constructor(
        private httpClient: HttpClient) {
    }

    init(): Observable<void> {
        return this.get()
            .pipe(
                map((response) => {
                    this.validators = response.validators;
                    this.regexes = response.regexes;
                }));
    }

    get(): Observable<ValidationDataMxObj> {
        return this.httpClient.get<ValidationDataMxObj>(VALIDATORS_DATA_URL);
    }

    public getValidator(type: ValidationType): Validator {
        return this.validators[type];
    }

    public getRegex(type: ValidationRegex) {
        return this.regexes[type];
    }

    public getRegexes(): string[] {
        return Object.keys(this.regexes);
    }

    public getClientValidatorTypes(): string[] {

        return Object.keys(this.validators)
            .map(s => this.validators[s]).filter(v => v.externalValidation === false)
            .map(v => v.name);
    }

    public getRegexTypes(): string[] {
        return Object.keys(this.regexes);
    }
}
